"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineItemErrorCode = void 0;
var LineItemErrorCode;
(function (LineItemErrorCode) {
    LineItemErrorCode["PRODUCT_NOT_FOUND"] = "PRODUCT_NOT_FOUND";
    LineItemErrorCode["MULTIPLE_MATCHING_DSKUS"] = "MULTIPLE_MATCHING_DSKUS";
    LineItemErrorCode["CASE_PACK_NOT_FOUND"] = "CASE_PACK_NOT_FOUND";
    LineItemErrorCode["INSUFFICIENT_INVENTORY"] = "INSUFFICIENT_INVENTORY";
    LineItemErrorCode["LOT_NOT_FOUND"] = "LOT_NOT_FOUND";
    LineItemErrorCode["FAILED_TO_RESOLVE_LINE_ITEM"] = "FAILED_TO_RESOLVE_LINE_ITEM";
})(LineItemErrorCode || (exports.LineItemErrorCode = LineItemErrorCode = {}));
//# sourceMappingURL=LineItemErrorCode.js.map